export default "__VITE_ASSET__CKUU$dch__"